import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import AlertSubscription from './alert-subscription'
import FormView from 'scoreboard/components/form-view'
import SubscriptionTypeTooltip from 'scoreboard/alerts/subscription-type-tooltip'
import Tooltip from 'scoreboard/components/tooltip'
import unwrapModel from 'scoreboard/components/unwrap-model'
import template from './domain-alert-subscription-form.hbs'

/**
 * An edit form for managing alert subscriptions for a single domain object.
 *
 * @property {Backbone.Model} model The domain object model (e.g. ScorecardNode)
 * @property {Subscription[]} model.subscriptions {id, type, comparison, threshold}
 */
const DomainAlertSubscriptionForm = Backbone.View.extend({

	tagName: 'form',

	className: 'form subscription-form domain-alert-subscription-form',

	events: {
		'click .add': 'onAdd',
		'click .delete': 'onDelete'
	},

	initialize(options = {}) {
		this.options = options
		this.subscriptionViews = []
		this.subscriptions = _.cloneDeep(this.model.get('subscriptions')) || []

		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.$el.empty().append(template(this.model.attributes))
		this.subscriptionSettings = this.$('.subscription-settings')
		if (this.subscriptions.length) {
			_.each(this.subscriptions, s => {
				this.renderSubscription(s)
			})
		} else {
			this.$('.empty-message').removeClass('is-not-displayed')
		}
		this.formView.start()
		return this
	},

	renderSubscription: function (subscription) {
		const view = new AlertSubscription({
			scorecardItem: unwrapModel(this.model),
			subscription,
			buttons: ['delete']
		})

		this.subscriptionViews.push(view)
		this.subscriptionSettings.append(view.el)
		view.render()
	},

	onAdd(e) {
		const subscriptionTypeTooltip = new SubscriptionTypeTooltip({
			model: this.model,
			subscriptions: false
		})

		this.tooltip = new Tooltip({
			extraClass: 'has-bootslide-menu',
			attachTo: e.target,
			content: subscriptionTypeTooltip,
			placement: 'below',
			arrow: 'right'
		}).render()

		subscriptionTypeTooltip.on('done', ({type}) => {
			this.$('.empty-message').addClass('is-not-displayed')

			const subscription = {domainId: this.model.id, type}
			this.subscriptions.push(subscription)
			this.renderSubscription(subscription)
			this.formView.setDirty()
		})
	},

	onDelete(e) {
		const jqEl = $(e.target).closest('.alert-settings')
		const index = jqEl.index()
		this.subscriptionViews[index].remove()
		this.subscriptionViews.splice(index, 1)
		this.subscriptions.splice(index, 1)
		if (!this.subscriptions.length) {
			this.$('.empty-message').removeClass('is-not-displayed')
		}
		this.formView.setDirty()
	},

	submit() {
		const subscriptions = _.map(this.subscriptionViews, s => s.updateSubscriptionWithFormValues())
		return $.ajax({
			method: 'patch',
			url: `api/scorecards/${this.model.id}/subscriptions`,
			data: JSON.stringify(subscriptions),
			success: ids => {
				_.each(ids => (id,i) => subscriptions[i].id = id)
				this.model.set('subscriptions', subscriptions)
				this.trigger('done', subscriptions)
			}
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.tooltip], 'remove')
		_.invokeMap(this.subscriptionViews, 'remove')
	}

})

export default DomainAlertSubscriptionForm

DomainAlertSubscriptionForm.__filename__ = 'alerts/domain-alert-subscription-form.js'
